"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getInputsFromState = getInputsFromState;
exports.inputsWithErrors = inputsWithErrors;

var _invariant = _interopRequireDefault(require("invariant"));

var _property2 = _interopRequireDefault(require("lodash/property"));

var _reduce2 = _interopRequireDefault(require("lodash/reduce"));

var _isEmpty2 = _interopRequireDefault(require("lodash/isEmpty"));

var _includes2 = _interopRequireDefault(require("lodash/includes"));

var _mountPoint = require("./mountPoint");

function getInputsFromState() {
  var inputConfigOrMountPoint = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _mountPoint.DEFAULT_REDUX_MOUNT_POINT;
  var state = arguments.length > 1 ? arguments[1] : undefined;
  var inputKeys = arguments.length > 2 ? arguments[2] : undefined;
  var mountPoint = typeof inputConfigOrMountPoint === 'string' ? inputConfigOrMountPoint : (0, _mountPoint.getReduxMountPoint)(inputConfigOrMountPoint);
  var inputsState = (0, _property2.default)(mountPoint)(state);
  (0, _invariant.default)(inputsState, "[redux-inputs]: no state found at '".concat(mountPoint, "', check your reducers to make sure it exists or change reduxMountPoint in your inputConfig."));

  if (inputKeys) {
    return (0, _reduce2.default)(inputsState, function (result, input, key) {
      if ((0, _includes2.default)(inputKeys, key)) {
        result[key] = input;
      }

      return result;
    }, {});
  } else {
    return inputsState;
  }
}

function inputsWithErrors(inputs) {
  var erroredInputs = (0, _reduce2.default)(inputs, function (result, input, key) {
    if (typeof input.error !== 'undefined') {
      result[key] = input;
    }

    return result;
  }, {});
  return (0, _isEmpty2.default)(erroredInputs) ? false : erroredInputs;
}


//////////////////
// WEBPACK FOOTER
// ./~/redux-inputs/lib/util/helpers.js
// module id = 343
// module chunks = 0